import { render, staticRenderFns } from "./RiskCheckDailySafetyLogAlways.vue?vue&type=template&id=bc9e6640&scoped=true&"
import script from "./RiskCheckDailySafetyLogAlways.vue?vue&type=script&lang=js&"
export * from "./RiskCheckDailySafetyLogAlways.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc9e6640",
  null
  
)

export default component.exports